import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AxiosError } from 'axios';

import accountGroupColumnDefinitions from '../utils/accountGroupColumnDefinitions';

import { ACCOUNT_GROUPS } from 'RestAPIs/endpoints';
import { useDeleteById } from 'RestAPIs/useDeleteById';

import TableCRUDLayout from 'components/shared/CRUD/TableCRUDLayout';
import WithInnerLayout from 'components/shared/CRUD/components/InnerPage/WithInnerLayout';
import useNavigateAfterCreate from 'components/shared/CRUD/components/InnerPage/hooks/useNavigateAfterCreate';
import { showErrorSnackbar } from 'components/shared/Snackbar';

import EditTabs from './edit/components/EditTabs';

import { useGetAccountGroups } from '../../../../../queries';
import CreateAccountGroupForm from './create/CreateAccountGroupForm';
import { getErrorMessageKey } from './utils';

const GrantsGrid = ({ isInnerLayoutOpen, setIsInnerLayoutOpen }) => {
  'use memo';

  const { t } = useTranslation('common');
  const [rowData, setRowData] = useState();
  const { data: accountGroups, isFetching, refetch } = useGetAccountGroups();
  const { mutateAsync: deleteRow } = useDeleteById(ACCOUNT_GROUPS, [
    'account-groups'
  ]);

  const handleDeleteRow = async (id) => {
    try {
      await deleteRow(id);
    } catch (err) {
      type DeleteGrantError = AxiosError<{
        error: { code: number; message: string };
      }>;
      showErrorSnackbar(t(getErrorMessageKey(err as DeleteGrantError)));
    }
  };

  const toggleInnerLayout = () => {
    setIsInnerLayoutOpen(!isInnerLayoutOpen);
  };

  const onViewClick = (rowData) => {
    setRowData(rowData);
    setIsInnerLayoutOpen(true);
  };

  useNavigateAfterCreate(accountGroups, onViewClick);

  if (isInnerLayoutOpen && rowData && accountGroups) {
    return (
      <EditTabs
        toggleInnerLayout={toggleInnerLayout}
        refreshList={refetch}
        rows={accountGroups}
        rowData={rowData}
      />
    );
  }

  return (
    <TableCRUDLayout
      FormComponent={(props) => (
        <CreateAccountGroupForm {...props} accountGroups={accountGroups} />
      )}
      rows={accountGroups}
      loading={isFetching}
      columns={accountGroupColumnDefinitions}
      getRowId={(row) => row.groupId}
      editable={false}
      confirmationTitle={t('deleteDialog.title')}
      confirmationBody={t('deleteDialog.body')}
      onViewClick={(id, row) => onViewClick(row)}
      onDeleteClick={handleDeleteRow}
    />
  );
};

const GrantsGridWithLayout = WithInnerLayout(GrantsGrid);
export default GrantsGridWithLayout;
